'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ServerLabel } from 'labels/server'
import { useMemo } from 'react'
import { useRefundData } from 'refunds/hooks/useRefundData/useRefundData'
import { isUniqueMethod } from 'refunds/utils/isUniqueMethod'

import text from 'fukku/styles/texts.module.scss'
import style from './Header.module.scss'

export function Header() {
	const { t } = useLabels()
	const { refundData } = useRefundData()

	const { bankData, accountBalance } = refundData ?? {}

	const subtitleText = useMemo(() => {
		const isUniqueMethodValue = isUniqueMethod(refundData)

		if (isUniqueMethodValue && accountBalance) {
			return 'myRefunds.onlineCredit.subtitle'
		}

		if (isUniqueMethodValue && bankData) {
			return 'myRefunds.wireTransfer.subtitle'
		}

		return 'myRefunds.refundOptions.subtitle'
	}, [bankData, accountBalance])

	return (
		<div className={style.container}>
			<h1
				data-testid='myRefunds.title'
				className={`${text.titleXL} ${style.title}`}
			>
				{t('myRefunds.title')}
			</h1>
			<p className={style.subtitle}>
				<ServerLabel paragraphProps={{ className: style.subtitle }}>
					{t(subtitleText)}
				</ServerLabel>
			</p>
		</div>
	)
}
